import { useEffect, useState } from "react";

import AlertComponent from "../../../helpers/alert/AlertComponent";
import { getCentralizationTitular } from "../../../entities/alerted-product";

// Consume alertas/titular/?identificacion=<documento_titular> para alimentar la
// sección "Información del titular" del detalle de Centralización.
export const useCentralizationTitular = (documentoTitular) => {
  const [titular, setTitular] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!documentoTitular) {
      setTitular(null);
      return undefined;
    }

    let cancelled = false;
    const fetchTitular = async () => {
      setLoading(true);
      try {
        const result = await getCentralizationTitular(documentoTitular);
        if (!cancelled) setTitular(result);
      } catch {
        if (cancelled) return;
        setTitular(null);
        AlertComponent.error(
          "Error",
          "No fue posible cargar la información del titular"
        );
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchTitular();
    return () => {
      cancelled = true;
    };
  }, [documentoTitular]);

  return { titular, loading };
};